export const Adjuntar = () => {
  return (
    <svg
      width="10"
      height="16"
      viewBox="0 0 12 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.91069 6.74541V14.0294C3.91939 14.5621 4.14425 15.0701 4.53674 15.4437C4.92924 15.8174 5.4579 16.0269 6.00864 16.0269C6.55938 16.0269 7.08804 15.8174 7.48053 15.4437C7.87303 15.0701 8.09789 14.5621 8.10659 14.0294L8.11339 4.48197C8.1191 4.02671 8.03133 3.57489 7.85516 3.15269C7.679 2.73048 7.41794 2.34631 7.08713 2.02242C6.75632 1.69854 6.36233 1.44139 5.92801 1.26588C5.49368 1.09037 5.02766 1 4.55696 1C4.08625 1 3.62023 1.09037 3.18591 1.26588C2.75158 1.44139 2.3576 1.69854 2.02678 2.02242C1.69597 2.34631 1.43492 2.73048 1.25875 3.15269C1.08258 3.57489 0.994813 4.02671 1.00052 4.48197V14.0937C0.990934 14.7347 1.11316 15.3711 1.36011 15.9659C1.60705 16.5607 1.97378 17.1021 2.43898 17.5587C2.90417 18.0152 3.45855 18.3777 4.06988 18.6251C4.68122 18.8726 5.3373 19 6 19C6.6627 19 7.31878 18.8726 7.93012 18.6251C8.54145 18.3777 9.09583 18.0152 9.56102 17.5587C10.0262 17.1021 10.3929 16.5607 10.6399 15.9659C10.8868 15.3711 11.0091 14.7347 10.9995 14.0937V5.11188"
        stroke="#3948FF"
        strokeWidth="1.5"
        strokemiterlimi="10"
        strokeLinecap="round"
      />
    </svg>
  );
};
